import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { CommonService } from '../../services/index';
import swal from 'sweetalert2';

@Component({
    selector: 'clientDocument-tab',
    templateUrl: './clientDocument.component.html'
})

export class clientDocumentComponent implements OnInit {
    @ViewChild('files') filesSel:ElementRef;
    client_id: number;
    isLoadMask: Promise<any>;
    fileData = [];
    filePath: string;
    userType: string;
    files: string;
    testingData = [];
    
    @Input() set getPopUp(event) {
        this.client_id = event.client_id;
        this.getFileList();
    }

    constructor(public commonService: CommonService, public bsModalRef: BsModalRef) {

    }

    ngOnInit(): void {
        this.bsModalRef.hide();
    }
    public getFileList() {
        let params = {
            client_id: this.client_id
        };
        let that = this;
        this.isLoadMask = this.commonService
            .getFileList(params)
            .then(function (res: any) {
                that.fileData = res.data;
                that.filePath = res.path;
                that.userType = res.userType;
            });
    }
    public uploadPhoto($event) {
        if ($event.target.files[0].size > 1000000) {
            return swal("File size is too big!!!");
        }
        this.files = $event.target.files[0];
        let params = {
            files: this.files,
            client_id: this.client_id
        };
        let that = this;
        this.isLoadMask = this.commonService
            .addPhoto(params)
            .then(function (res: any) {
                if(res){
                   
                    // swal('SUCCESS', 'Document Upload Successfully');
                    that.getFileList();
                    that.testingData = res.data;
                   
                    // swal(
                    //     'Document Upload Successfully',
                    //     res.message,
                    //     'success'       
                    // );
                }
                if(res.data.success)
                {
                   swal(
                        'Document Upload Successfully',
                        res.message,
                        'success'       
                    );
                }
            });
    }
    onDeleteDocument(row: any): void {
        let fileId = row.doc_id;
        let that = this,
            msgTitle = 'Error',
            msgType = 'error',
            data = {
                file_id: fileId
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover File:' + row.file_name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.commonService
                .deleteDocument(fileId)
                .then(function (res: any) {
                    if (res.success) {
                        that.getFileList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/clientDocument.component.ts